import React, { useEffect, useState } from "react"; 
import { Link,useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import { API_BASE_URL } from "../config";

const Stockcarryorders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(0); // 🔥 triggers rerender when markup table changes

  useEffect(() => {
    const fetchOrders = async () => {
      let userData = localStorage.getItem("user");

      if (!userData) {
        console.error("No user data found in localStorage");
        return;
      }

      try {
        const user = JSON.parse(userData);
        const userId = user?.userId;
        const companyid = user?.companyId;

        const response = await axios.get(
          `${API_BASE_URL}/Order/GetOrderItemsDetails?userId=${userId}&companyid=${companyid}`
        );

        setOrders(response.data.data || []);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, [forceUpdate]); // ⬅ rerender when markup table changes

  // 🔥 LIVE MARKUP FUNCTION
  const applyMarkup = (base) => {
    const view = localStorage.getItem("activeView") || "wholesale";
    if (view === "wholesale") return base;

    const storedPayload = JSON.parse(localStorage.getItem("priceTable_seller") || "{}");
    const table = Array.isArray(storedPayload.data) ? storedPayload.data : [];

    if (!table.length) return base;

    const range = table.find((r) => {
      const from = parseFloat(r.from || 0);
      const to = r.to === null ? Infinity : parseFloat(r.to);
      return base >= from && base <= to;
    });

    if (!range) return base;

    const markupPercent = parseFloat(range.markup || 0);
    return base * markupPercent;
  };

  // 🔥 LISTEN FOR LOCALSTORAGE CHANGE WITHOUT REFRESH
  useEffect(() => {
    const update = () => setForceUpdate((n) => n + 1);

    window.addEventListener("storage", update);
    window.addEventListener("activeViewChanged", update);
    window.addEventListener("markupTableChanged", update);

    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener("activeViewChanged", update);
      window.removeEventListener("markupTableChanged", update);
    };
  }, []);

  return (
    <>
      <div className="home">
        <div id="page" className="hfeed page-wrapper">
          <Header />

          <div id="site-main" className="site-main">
            <div id="main-content" className="main-content">
              <div id="primary" className="content-area">
                <div id="content" className="site-content" role="main">
                  <div className="section-padding">
                    <div className="section-container p-l-r" id="yourOrders-section">
                      <div className="tab-container">
                        <h2 className="text-center">
                          <Link
                            to="/partnerdashboard"
                            style={{ color: "black" }}
                            className="btn btn-view"
                          >
                            <i className="fa fa-arrow-left" aria-hidden="true"></i>
                          </Link>
                          {" "}
                         Stock and Carry Orders
                        </h2>
<hr/>
                        <br />

                        <div className="products-list grid">
                          <div className="row">
  {orders.length > 0 ? (
  orders
    .filter(order => order.StockCarry === "Stockandcarry") // ⭐ FILTER
    .sort((a, b) => b.OrderID - a.OrderID)
    .map((order) => (
      <div
        key={`${order.OrderID}-${order.OrderItemID}`}
        className="col-md-3"
      >
        <div
          className="customise-product"
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate(`/stockcarrydetails/${order.OrderID}/${order.OrderItemID}`)
          }
        >
          <img
            src={order.ProductImage}
            alt="Order"
            style={{ width: "100%", borderRadius: "10px" }}
          />

          <div className="details">
            <div>
              <strong>Order ID:</strong>{" "}
              {order.OrderID} - {order.ProductCode}
            </div>

            <div>
              <strong>Order Reference:</strong>{" "}
              {order.OrderReference}
            </div>

            <div>
              <strong>Qty:</strong> {order.Quantity}
            </div>

            <div>
              <strong>Total Amount:</strong>{" "}
              {order.Currency} {Math.round(applyMarkup(order.ProductPrice))}
            </div>

            <div>
              <strong>Status:</strong>{" "}
              <span
                style={{
                  color:
                    order.StatusName === "Delivered" ? "green" : "#000",
                }}
              >
                {order.StatusName}
              </span>
            </div>

            <div>
              <strong>Order Date:</strong>{" "}
              {new Date(order.OrderDate).toLocaleDateString()}
            </div>

            <div>
              <strong>Client Delivery Date:</strong>{" "}
              {new Date(order.DeliveryDate).toLocaleDateString()}
            </div>
          </div>

          <button
            className="btn btn-view"
            onClick={(e) => {
              e.stopPropagation();
              navigate(
                `/stockcarrydetails/${order.OrderID}/${order.OrderItemID}`
              );
            }}
          >
            View Order
          </button>
        </div>
      </div>
    ))
) : (
  <p>No orders found.</p>
)}

</div>

                        
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};

export default Stockcarryorders;
